import React, { useContext } from "react";
import type { DrawerFilters } from "./Filter.context";

type FiltersDrawerContextType = {
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  drawerFilters: DrawerFilters;
  setDrawerFilters: React.Dispatch<React.SetStateAction<DrawerFilters>>;
};

const FiltersDrawerContext = React.createContext<FiltersDrawerContextType>({
  open: false,
  drawerFilters: { status: [], channels: [], critical: [] },
  setDrawerFilters: () => undefined,
});

export const useFiltersDrawerContext = () => useContext(FiltersDrawerContext);

export default FiltersDrawerContext;
